// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GLOBAL */
body {
  background-color: #f3f2f2;
  margin: 0;
}
.border_dash {
  border: 1px dashed;
}
.fn_xxs {
  font-size: 10px;
}
.fn_xs {
  font-size: 12px !important;
}
.fn_sm {
  font-size: 13px;
}
.ls-1 {
  letter-spacing: 1px;
}
.cursor-pointer {
  cursor: pointer;
}
/* BACKGROUND COLOR */
.bg_dark {
  background-color: #1c1f3e;
}
.bg_light {
  background-color: #f3f2f2;
}

/* FONT COLOR */
.fn_light {
  color: #f3f2f2 !important;
}
.fn_main {
  color: #535353;
}
.fn_primary {
  color: blue;
}

/* WIDTH */
.w_10 {
  width: 10%;
}
.w_15 {
  width: 15%;
}
.w_20 {
  width: 20%;
}
.w_30 {
  width: 30% !important;
}
.w_40 {
  width: 40% ;
}
.w_70 {
  width: 70%;
}
.w_90 {
  width: 90% !important;
}
.w_5 {
  width: 50px !important;
}
.w_6 {
  width: 60px !important;
}
.w_120 {
  width: 120px;
}
.w_100 {
  width: 100px;
}
.h_1 {
  height: 10px;
}
.h_2 {
  height: 20px;
}
.h_3 {
  height: 30px;
}
.h_4 {
  height: 40px;
}
.h_5 {
  height: 50px;
}
.h_6 {
  height: 60px;
}
.h_300{
  height: 300px;
}

/* distance */
.me_5 {
  margin-right: 5%;
}
.ml_30{
  margin-left: 30%;
}

/* General */

input:focus,
textarea:focus {
  outline: none;
}
#sender {
  text-align: start !important;
  margin-left: 10px !important;
}
/* SCROLLBAR */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background: #6872e2;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1c1f3e;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,YAAY;;AAEZ;;EAEE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA,cAAc;AACd;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* GLOBAL */\nbody {\n  background-color: #f3f2f2;\n  margin: 0;\n}\n.border_dash {\n  border: 1px dashed;\n}\n.fn_xxs {\n  font-size: 10px;\n}\n.fn_xs {\n  font-size: 12px !important;\n}\n.fn_sm {\n  font-size: 13px;\n}\n.ls-1 {\n  letter-spacing: 1px;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n/* BACKGROUND COLOR */\n.bg_dark {\n  background-color: #1c1f3e;\n}\n.bg_light {\n  background-color: #f3f2f2;\n}\n\n/* FONT COLOR */\n.fn_light {\n  color: #f3f2f2 !important;\n}\n.fn_main {\n  color: #535353;\n}\n.fn_primary {\n  color: blue;\n}\n\n/* WIDTH */\n.w_10 {\n  width: 10%;\n}\n.w_15 {\n  width: 15%;\n}\n.w_20 {\n  width: 20%;\n}\n.w_30 {\n  width: 30% !important;\n}\n.w_40 {\n  width: 40% ;\n}\n.w_70 {\n  width: 70%;\n}\n.w_90 {\n  width: 90% !important;\n}\n.w_5 {\n  width: 50px !important;\n}\n.w_6 {\n  width: 60px !important;\n}\n.w_120 {\n  width: 120px;\n}\n.w_100 {\n  width: 100px;\n}\n.h_1 {\n  height: 10px;\n}\n.h_2 {\n  height: 20px;\n}\n.h_3 {\n  height: 30px;\n}\n.h_4 {\n  height: 40px;\n}\n.h_5 {\n  height: 50px;\n}\n.h_6 {\n  height: 60px;\n}\n.h_300{\n  height: 300px;\n}\n\n/* distance */\n.me_5 {\n  margin-right: 5%;\n}\n.ml_30{\n  margin-left: 30%;\n}\n\n/* General */\n\ninput:focus,\ntextarea:focus {\n  outline: none;\n}\n#sender {\n  text-align: start !important;\n  margin-left: 10px !important;\n}\n/* SCROLLBAR */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 5px;\n}\n::-webkit-scrollbar-thumb {\n  background: #6872e2;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #1c1f3e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
